<template>
    <ContainerLayout page="0" :padding="false">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div class="p-2 my-1">
                <div class="d-flex flex-column">
                    <div class="d-flex flex-column pb-3">
                        <small style="font-weight: 600;">
                            {{ billing.branch.location.current_name + ' - ' +
                                (billing.branch.location.airport_code ? billing.branch.location.airport_code +
                                    ', ' : '') + billing.branch.location.city + ', ' +
                                billing.branch.location.province }}
                        </small>
                    </div>
                    <hr class="my-0 full-hr" style="border-top: 1.5px solid rgba(0,0,0,.1);">
                    <div class="d-flex flex-column py-2">
                        <small style="font-weight: 700; font-size: 12.5px;">
                            {{ $t('Destination') }}
                        </small>
                        <div class="my-1">
                            <div v-if="billing.branch.name || billing.branch.brand" class="d-flex align-items-center">
                                <small style="font-size: 12px; font-weight: 500;">
                                    {{ billing.branch.name }} <span style="font-size: 11px; font-weight: 400;">{{
                                        billing.branch.brand ? ' - ' + billing.branch.brand : '' }}</span>
                                </small>
                            </div>
                            <div v-if="billing.branch.phone" class="d-flex align-items-center">
                                <small class="text-muted" style="font-size: 11px;">
                                    {{ billing.branch.phone }}
                                </small>
                            </div>
                            <div v-if="billing.branch.address" class="d-flex align-items-center">
                                <small class="text-muted" style="font-size: 11px;">
                                    {{ billing.branch.address }}
                                </small>
                            </div>
                            <div v-if="billing.branch.receiver_name || billing.branch.receiver_phone"
                                class="d-flex align-items-center">
                                <small style="font-size: 11px;">
                                    {{ $t('PIC') }} : {{ billing.branch.receiver_name }}
                                    ({{ billing.branch.receiver_phone }})
                                </small>
                            </div>
                        </div>
                    </div>
                    <hr class="my-0 full-hr" style="border-top: 7px solid rgba(0,0,0,.1);">
                </div>
                <div class="d-flex flex-column mt-3">
                    <div class="d-flex align-items-center my-1">
                        <small style="font-size: 12px; font-weight: 500;">
                            {{ $t('Destination ID') }}
                        </small>
                        <div class="ml-auto d-flex align-items-center">
                            <small style="font-size: 12px;">
                                {{ billing.customer_id }}
                            </small>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-1">
                        <small style="font-size: 12px; font-weight: 500;">
                            {{ $t('Service Name') }}
                        </small>
                        <div class="ml-auto d-flex align-items-center">
                            <small style="font-size: 12px;">
                                {{ billing.mikrotik_billing_transactions[0].tx_product.current_product_category_name
                                }}
                            </small>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-1">
                        <small style="font-size: 12px; font-weight: 500;">
                            {{ $t('Activated At') }}
                        </small>
                        <div class="ml-auto d-flex align-items-center">
                            <small v-if="billing.initial_started_at" style="font-size: 12px;">
                                {{ formatDateDay(billing.initial_started_at) }}
                            </small>
                            <small v-else class="mr-1" style="font-size: 12px;">
                                -
                            </small>
                        </div>
                    </div>
                    <div class="d-flex align-items-center my-1">
                        <small style="font-size: 12px; font-weight: 500;">
                        </small>
                        <div class="ml-auto d-flex align-items-center">
                            <router-link :to="{ path: '', query: { ...$route.query } }"
                                @click.prevent="openIframe(this.api_url + '/mikrotik_billing/report/' + billing.id + '?view=iframe', '{{ billing.report_number }}')"
                                class="text-main" style="font-size: 12px; font-weight: 500;">
                                {{ $t('View Activation Report') }}
                            </router-link>
                        </div>
                    </div>
                    <div class="card mt-3 mb-4"
                        style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                        <div class="my-1 mx-2">
                            <div class="d-flex align-items-center my-1">
                                <small style="font-size: 12px; font-weight: 500;">
                                    {{ $t('Status') }}
                                </small>
                                <div class="ml-auto d-flex align-items-center">
                                    <span v-if="billing.status_label == 'Active'" class="badge badge-success"
                                        style="font-size: 12px;">
                                        {{ billing.status_label }}
                                    </span>
                                    <span v-else-if="billing.status_label == 'Inactive'" class="badge badge-secondary"
                                        style="font-size: 12px;">
                                        {{ billing.status_label }}
                                    </span>
                                    <span v-else class="badge badge-warning text-white" style="font-size: 12px;">
                                        {{ billing.status_label }}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex align-items-center my-1">
                                <small style="font-size: 12px; font-weight: 500;">
                                    {{ $t('Started At') }}
                                </small>
                                <div class="ml-auto d-flex align-items-center">
                                    <small v-if="billing.started_at" style="font-size: 12px;">
                                        {{ formatDateDay(billing.started_at) }}
                                    </small>
                                    <small v-else class="mr-1" style="font-size: 12px;">
                                        -
                                    </small>
                                </div>
                            </div>
                            <div class="d-flex align-items-center my-1">
                                <small style="font-size: 12px; font-weight: 500;">
                                    {{ $t('Remaining Duration') }}
                                </small>
                                <div class="ml-auto d-flex align-items-center">
                                    <small v-if="billing.duration" style="font-size: 12px;">
                                        {{ billing.duration + ' ' + billing.current_duration_type }}
                                    </small>
                                    <small v-else class="mr-1" style="font-size: 12px;">
                                        -
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="my-0 full-hr py-1" style="border-top: 7px solid rgba(0,0,0,.1);">
                </div>
                <div class="d-flex flex-column mt-3">
                    <small style="font-weight: 700; font-size: 12.5px;">
                        {{ $t('Transactions') }}
                    </small>
                    <div class="w-100 d-flex flex-row justify-content-start align-items-center mt-1 mb-2"
                        style="overflow-x: auto; overflow-y: hidden; white-space: nowrap;">
                        <div v-for="(mikrotik_billing_transaction, index) in billing.mikrotik_billing_transactions"
                            :key="index" class="card mr-2 mb-3 mt-1 h-100"
                            style="width: 280px !important; flex-shrink: 0; border-radius: 0.25rem; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);"
                            :style="mikrotik_billing_transaction.id == billing.current_billing_transaction_id ? 'border: 1.5px solid #275D93;' : 'border: 1.5px solid rgba(0,0,0,.125)'">
                            <div class="card-header p-1">
                                <div class="d-flex align-items-center p-1">
                                    <span style="font-size: 12px;"
                                        :class="mikrotik_billing_transaction.id == billing.current_billing_transaction_id ? 'badge badge-main' : 'badge badge-outline badge-secondary'">
                                        {{ mikrotik_billing_transaction.transaction.invoice_number }}
                                    </span>
                                </div>
                            </div>
                            <div class="my-1 mx-2">
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Account') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center ellipsis">
                                        <small style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.transaction.user.name }}
                                        </small>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Product') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center ellipsis">
                                        <small style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.tx_product.current_product_name }}
                                        </small>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Type') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center ellipsis">
                                        <small style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.tx_product.product_detail_detail_label }}
                                        </small>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Paid At') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center ellipsis">
                                        <small style="font-size: 12px;">
                                            {{ formatDateTime(mikrotik_billing_transaction.transaction.paid_at) }}
                                        </small>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Status') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center ellipsis">
                                        <small v-if="mikrotik_billing_transaction.status_label == '-'" class="mr-1"
                                            style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.status_label }}
                                        </small>
                                        <span v-else-if="mikrotik_billing_transaction.status_label == 'Active'"
                                            class="badge badge-success" style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.status_label }}
                                        </span>
                                        <span v-else-if="mikrotik_billing_transaction.status_label == 'Finished'"
                                            class="badge badge-main" style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.status_label }}
                                        </span>
                                        <span v-else-if="mikrotik_billing_transaction.status_label == 'Pending'"
                                            class="badge badge-secondary" style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.status_label }}
                                        </span>
                                        <span v-else class="badge badge-warning text-white" style="font-size: 12px;">
                                            {{ mikrotik_billing_transaction.status_label }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">
            <div class="p-2 my-1">
                <div v-for="(item, index) in [1, 2, 3]" :key="index"
                    class="d-flex align-items-start my-1 position-relative pb-4">
                    <div class="skeleton-card" />
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import TransactionService from "@/services/transaction.service";
import moment from 'moment';
// import { ref } from 'vue';

export default {
    name: "TransactionServiceDetail",
    components: {
        ContainerLayout,
    },
    data() {
        return {
            loaded_data: false,
            loading: false,
            billing: null,
            isSpinning: false,
            api_url: process.env.VUE_APP_BACKEND_URL,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        if (!this.$route.query.id) {
            this.$router.push("/transaction");
        } else {
            this.loadData();
        }
    },
    methods: {
        goBack() {
            this.navigateBackOrHome();
        },

        loadData() {
            this.loading = true;
            let loader = this.$loading.show();
            TransactionService
                .getMikrotikBillingById(this.$route.query.id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.billing = response.data.data;
                        this.loaded_data = true;
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                            this.goBack();
                        });
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                        this.goBack();
                    });
                });
        },

        formatDateTime(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('DD MMM YYYY, HH:mm');
        },

        formatDateDay(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('dddd, DD MMM YYYY');
        },

        formatTime(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('HH:mm');
        },

        openIframe(url, name) {
            let data = {
                url: url,
                name: name,
            }

            this.$router.push({
                name: "File Preview",
                query: {
                    data: this.$encryptString(JSON.stringify(data), 'encryptKey'),
                }
            });
        },
    },
};
</script>

<style scoped>
.skeleton-card {
    width: 100%;
    height: 189.8px;
    background-color: #e6e6e6;
    border-radius: 5px;
}

.full-hr {
    margin-left: -12px;
    margin-right: -12px;
}

.ellipsis {
    max-width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>